import { render, staticRenderFns } from "./GoogleStatCosts.vue?vue&type=template&id=40a5693a&"
import script from "./GoogleStatCosts.vue?vue&type=script&lang=js&"
export * from "./GoogleStatCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports